var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
//components
import { makeStyles } from "@material-ui/core";
//types
import { FTLTypography } from "../FTLTypography";
import { Link } from "react-router-dom";
export const FTLLink = React.forwardRef((_a, ref) => {
    var { variant = "p3", color, children } = _a, otherProps = __rest(_a, ["variant", "color", "children"]);
    const classes = useStyles({ color });
    return (React.createElement(Link, Object.assign({}, otherProps, { ref: ref, className: classes.link }),
        React.createElement(FTLTypography, { variant: variant, className: classes.typography }, children)));
});
const useStyles = makeStyles((theme) => ({
    link: {
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
        "&:disabled > $typography": {
            color: theme.palette.link.disabled,
            textDecoration: "none",
        },
    },
    typography: ({ color = "primary" }) => ({
        cursor: "pointer",
        color: color !== "inherit" ? theme.palette.link[color] : "inherit",
        textDecoration: "none",
        "&:hover": {
            color: theme.palette.link.hover,
            textDecoration: "underlined",
        },
        "&:disabled": {
            color: theme.palette.link.disabled,
            textDecoration: "none",
        },
    }),
}));
//# sourceMappingURL=index.js.map